// Etat de l'ecran SuperAdmin "Produits" (produits canoniques, tous comptes).
export function superAdminProductReducer(state = {
    produits: [],
    totaux: {},
    loading: false,
    error: "",
    withStock: false,
    loaded: false,
}, {
    type,
    payload
}) {

    switch (type) {
        case "FETCH_SUPERADMIN_PRODUCTS_START":
            return {
                ...state,
                loading: true,
                error: "",
            };

        case "FETCH_SUPERADMIN_PRODUCTS_FULFILLED":
            return {
                ...state,
                loading: false,
                error: "",
                loaded: true,
                produits: payload.produits,
                totaux: payload.totaux,
                withStock: payload.withStock,
            };

        case "FETCH_SUPERADMIN_PRODUCTS_ERROR":
            return {
                ...state,
                loading: false,
                loaded: true,
                error: payload,
            };

        default:
            return state;
    }

}
